import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { defaultFormData, initialState } from "./initialState";
import {  IData } from "../types";
import { DataActiveStatusEnum } from "../../Category/types";

export const useClinicSlice = createSlice({
  name: "categoryRetailerState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setToggleLoading: (state, action: PayloadAction<boolean>) => {
      state.toggleLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },

    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    clearFrom: (state) => {
      state.formData= { ...defaultFormData };
    },
    doCreate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdateStatus: (
      state,
      action: PayloadAction<{
        id: string;
        index: number;
        callback: () => void;
      }>
    ) => {
      state.list[action.payload.index].status =
        state.list[action.payload.index].status === DataActiveStatusEnum.ACTIVE
          ? DataActiveStatusEnum.INACTIVE
          : DataActiveStatusEnum.ACTIVE;
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    doGetList: (state) => {
      if (!state.toggleLoading) {
        state.loading = true;
      }
    },
    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IData>) => {
      state.formData = action.payload;
    },
    doGetAllCategoryList: (state) => {},
    setAllList: (state, action: PayloadAction<Array<IData>>) => {
      state.allList = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
